<button class="new-chat-button" type="button" (click)="onClick()">
  <span class="new-chat-button__icon">
    <cwc-icon name="edit-text"></cwc-icon>
  </span>

  <span class="new-chat-button__label"> New Chat </span>
</button>
